import { Mui } from "@osu/react-ui";
import { selectFavoritedLinks } from "../../services/graphql/slices/preferences";
import { useSelector } from "react-redux";
import { navLinkDropdownStyles } from "../../styles/commonSx";
import { Link } from "react-router-dom";
import { linkablePathValues } from "../../Routes/paths";
import { mergeSxStyles } from "../../styles/util";

export default function Favorites({ sx, ...props }) {
  const favoritedLinks = useSelector((state) => {
    return selectFavoritedLinks(state) ?? [];
  });

  if (!favoritedLinks?.length) {
    return (
      <Mui.ListItem {...props} sx={mergeSxStyles(sx, {
        display: 'inline-block'
      })}>
        You don’t have any favorites yet! Visit the{" "}
        <Mui.Link
          sx={(theme) => ({ fontWeight: theme.typography.fontWeightBold })}
          component={Link}
          to={linkablePathValues.search}
        >
          search page
        </Mui.Link>{" "}
        and favorite links to access them here.
      </Mui.ListItem>
    );
  }

  return favoritedLinks.map(({ link, title }, i) => (
        <Mui.MenuItem key={'menuitem' + i + encodeURIComponent((title ?? "").slice(0, 5))} sx={sx} className="padding-y-0" disableGutters  {...props}>
          <Mui.ListItemButton
            sx={navLinkDropdownStyles}
            component="a"
            href={link}
          >
            {title}
          </Mui.ListItemButton>
        </Mui.MenuItem>
      )
  );
}
